import { Environments } from '@sennder/federated-module-loader'

export const ENV = process.env.VUE_APP_ENV as Exclude<Environments, 'hot'>
export const APP_VERSION = process.env.VUE_APP_VERSION
export const CARRIER_PROFILE_URL = process.env.VUE_APP_CARRIER_PROFILE_URL
export const LD_KEY = process.env.VUE_APP_LD_KEY
export const LD_USER_STATIC_KEY = process.env.VUE_APP_LD_USER_STATIC_KEY
export const DATADOG_APP_ID = process.env.VUE_APP_DATADOG_APP_ID
export const HOTJAR_PROJECT_ID = process.env.VUE_APP_HOTJAR_PROJECT_ID
export const DATADOG_CLIENT_TOKEN = process.env.VUE_APP_DATADOG_CLIENT_TOKEN
export const AMPLITUDE_API_KEY = process.env.VUE_APP_AMPLITUDE_API_KEY
export const TRANSLATIONS_URL = process.env.VUE_APP_TRANSLATIONS_URL
export const CARRIER_USER_SERVICE_URL =
  process.env.VUE_APP_CARRIER_USER_SERVICE_URL
export const CARRIER_USER_SERVICE_AUDIENCE =
  process.env.VUE_APP_CARRIER_USER_SERVICE_AUDIENCE
export const CARRIER_PROFILE_PUBLIC_SERVICE_URL =
  process.env.VUE_APP_CARRIER_PROFILE_PUBLIC_SERVICE_URL
export const PERMISSIONS_SERVICE_URL =
  process.env.VUE_APP_PERMISSIONS_SERVICE_URL

export const IS_LOCALHOST = window.location.hostname === 'localhost'
export const AUTH0_API_AUDIENCE = process.env.VUE_APP_AUTH0_API_AUDIENCE

export const AUTH0_USE_TOKEN_POPUP = false

export const isLocalEnv = (): boolean => {
  return ENV === 'dev'
}

export function isUatEnv(): boolean {
  return ENV === 'uat'
}

export function isProductionEnv(): boolean {
  return ENV === 'prod'
}

export const MASK_SENSITIVE_DATA = true
